module.exports = __webpack_public_path__ + "img/leisure.9f669f47.gif";